import { useEffect, useState } from "react";
import { readClientId } from "./personal";

/**
 * Arriving at the convention guide from another door.
 *
 * The guide's cookie is a `__Host-` one, which a browser will only ever send to the exact
 * host that set it. So a staff sign-in cannot hand the guide a session directly, however
 * much the two doors belong to the same person. It hands over a one-use token instead, and
 * this page spends it here, where the cookie can be set on the host that will send it.
 */
export function GuideEntry() {
  const [message, setMessage] = useState("Opening the convention guide…");

  useEffect(() => {
    const token = new URLSearchParams(window.location.hash.slice(1)).get("t");
    // Out of the address bar before anything else, so it cannot be shared by accident.
    window.history.replaceState(null, "", "/");
    if (!token) {
      setMessage("That link is incomplete. Open the guide again from the staff workspace.");
      return;
    }
    void fetch("/api/attendee/guide-handoff", {
      method: "POST",
      credentials: "same-origin",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({ token, clientId: readClientId() }),
    }).then(async (response) => {
      if (!response.ok) {
        const body = await response.json().catch(() => null) as { message?: string } | null;
        throw new Error(body?.message ?? "That link could not be used.");
      }
      // A full load, so every part of the guide starts from the new session.
      window.location.replace("/");
    }).catch((error: unknown) => {
      setMessage(error instanceof Error ? error.message : "That link could not be used.");
    });
  }, []);

  return (
    <main className="school-portal-message" aria-live="polite">
      <h1>WVCEA Connect</h1>
      <p>{message}</p>
    </main>
  );
}
